// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file readiness/v1/readiness.proto (package readiness.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file readiness/v1/readiness.proto.
 */
export const file_readiness_v1_readiness: GenFile = /*@__PURE__*/
  fileDesc("ChxyZWFkaW5lc3MvdjEvcmVhZGluZXNzLnByb3RvEgxyZWFkaW5lc3MudjEiDgoMQ2hlY2tSZXF1ZXN0IjMKDVNlcnZpY2VTdGF0dXMSEgoKbGF0ZW5jeV91cxgBIAEoARIOCgZzdGF0dXMYAiABKAkioQEKEEhlYWx0aENoZWNrU3RhdHMSLQoIZGF0YWJhc2UYASABKAsyGy5yZWFkaW5lc3MudjEuU2VydmljZVN0YXR1cxItCgh0ZW1wb3JhbBgCIAEoCzIbLnJlYWRpbmVzcy52MS5TZXJ2aWNlU3RhdHVzEi8KCmJsb2Jfc3RvcmUYAyABKAsyGy5yZWFkaW5lc3MudjEuU2VydmljZVN0YXR1cyJzCg1DaGVja1Jlc3BvbnNlEg0KBXJlcGx5GAEgASgJEg8KB21lc3NhZ2UYAiABKAkSLQoFc3RhdHMYAyABKAsyHi5yZWFkaW5lc3MudjEuSGVhbHRoQ2hlY2tTdGF0cxITCgtlbnZpcm9ubWVudBgEIAEoCSISChBDaGVja0F1dGhSZXF1ZXN0IlAKEUNoZWNrQXV0aFJlc3BvbnNlEg4KBnN0YXR1cxgBIAEoCRIPCgdtZXNzYWdlGAIgASgJEhoKEmF1dGhlbnRpY2F0ZWRfdXNlchgDIAEoCTJWCg1TdGF0dXNTZXJ2aWNlEkUKBUNoZWNrEhoucmVhZGluZXNzLnYxLkNoZWNrUmVxdWVzdBobLnJlYWRpbmVzcy52MS5DaGVja1Jlc3BvbnNlIgOQAgEyZgoRQXV0aFN0YXR1c1NlcnZpY2USUQoJQ2hlY2tBdXRoEh4ucmVhZGluZXNzLnYxLkNoZWNrQXV0aFJlcXVlc3QaHy5yZWFkaW5lc3MudjEuQ2hlY2tBdXRoUmVzcG9uc2UiA5ACAUJFWkNnaXRodWIuY29tL3VuaXBob3JlL3N1bnN0b25lL3BrZy9nby9nZW4vcGIvcmVhZGluZXNzL3YxO3JlYWRpbmVzc1YxYgZwcm90bzM");

/**
 * @generated from message readiness.v1.CheckRequest
 */
export type CheckRequest = Message<"readiness.v1.CheckRequest"> & {
};

/**
 * Describes the message readiness.v1.CheckRequest.
 * Use `create(CheckRequestSchema)` to create a new message.
 */
export const CheckRequestSchema: GenMessage<CheckRequest> = /*@__PURE__*/
  messageDesc(file_readiness_v1_readiness, 0);

/**
 * @generated from message readiness.v1.ServiceStatus
 */
export type ServiceStatus = Message<"readiness.v1.ServiceStatus"> & {
  /**
   * Latency in microseconds
   *
   * @generated from field: double latency_us = 1;
   */
  latencyUs: number;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message readiness.v1.ServiceStatus.
 * Use `create(ServiceStatusSchema)` to create a new message.
 */
export const ServiceStatusSchema: GenMessage<ServiceStatus> = /*@__PURE__*/
  messageDesc(file_readiness_v1_readiness, 1);

/**
 * @generated from message readiness.v1.HealthCheckStats
 */
export type HealthCheckStats = Message<"readiness.v1.HealthCheckStats"> & {
  /**
   * @generated from field: readiness.v1.ServiceStatus database = 1;
   */
  database?: ServiceStatus;

  /**
   * @generated from field: readiness.v1.ServiceStatus temporal = 2;
   */
  temporal?: ServiceStatus;

  /**
   * @generated from field: readiness.v1.ServiceStatus blob_store = 3;
   */
  blobStore?: ServiceStatus;
};

/**
 * Describes the message readiness.v1.HealthCheckStats.
 * Use `create(HealthCheckStatsSchema)` to create a new message.
 */
export const HealthCheckStatsSchema: GenMessage<HealthCheckStats> = /*@__PURE__*/
  messageDesc(file_readiness_v1_readiness, 2);

/**
 * @generated from message readiness.v1.CheckResponse
 */
export type CheckResponse = Message<"readiness.v1.CheckResponse"> & {
  /**
   * @generated from field: string reply = 1;
   */
  reply: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: readiness.v1.HealthCheckStats stats = 3;
   */
  stats?: HealthCheckStats;

  /**
   * Current Sunstone deployment tier: "development" | "staging" | "production"
   * | other envs.Environment values (e.g. "local", "test", "canary", "garden").
   *
   * @generated from field: string environment = 4;
   */
  environment: string;
};

/**
 * Describes the message readiness.v1.CheckResponse.
 * Use `create(CheckResponseSchema)` to create a new message.
 */
export const CheckResponseSchema: GenMessage<CheckResponse> = /*@__PURE__*/
  messageDesc(file_readiness_v1_readiness, 3);

/**
 * @generated from message readiness.v1.CheckAuthRequest
 */
export type CheckAuthRequest = Message<"readiness.v1.CheckAuthRequest"> & {
};

/**
 * Describes the message readiness.v1.CheckAuthRequest.
 * Use `create(CheckAuthRequestSchema)` to create a new message.
 */
export const CheckAuthRequestSchema: GenMessage<CheckAuthRequest> = /*@__PURE__*/
  messageDesc(file_readiness_v1_readiness, 4);

/**
 * @generated from message readiness.v1.CheckAuthResponse
 */
export type CheckAuthResponse = Message<"readiness.v1.CheckAuthResponse"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string authenticated_user = 3;
   */
  authenticatedUser: string;
};

/**
 * Describes the message readiness.v1.CheckAuthResponse.
 * Use `create(CheckAuthResponseSchema)` to create a new message.
 */
export const CheckAuthResponseSchema: GenMessage<CheckAuthResponse> = /*@__PURE__*/
  messageDesc(file_readiness_v1_readiness, 5);

/**
 * @generated from service readiness.v1.StatusService
 */
export const StatusService: GenService<{
  /**
   * @generated from rpc readiness.v1.StatusService.Check
   */
  check: {
    methodKind: "unary";
    input: typeof CheckRequestSchema;
    output: typeof CheckResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_readiness_v1_readiness, 0);

/**
 * AuthStatusService provides authenticated health check endpoints that require valid JWT tokens.
 * This service is used to verify that the authentication system is working correctly.
 *
 * @generated from service readiness.v1.AuthStatusService
 */
export const AuthStatusService: GenService<{
  /**
   * CheckAuth verifies that authentication is working by requiring a valid JWT token.
   * This endpoint requires authentication and will return the authenticated user's subject.
   *
   * @generated from rpc readiness.v1.AuthStatusService.CheckAuth
   */
  checkAuth: {
    methodKind: "unary";
    input: typeof CheckAuthRequestSchema;
    output: typeof CheckAuthResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_readiness_v1_readiness, 1);

